import React from 'react'
import CardContent from '@mui/material/CardContent'
import styled from 'styled-components'

import { ActionCardProps } from 'types/TextAnalysis'
import { CardTitle } from './CardTitle'
import { CardContentDesc } from './CardContent'
import { IdeasCommentTitleLink } from './IdeasCommentTitleLink'

const Wrapper = styled(CardContent)<{ $show: boolean }>`
  padding: 0 !important;
  padding-left: ${({ $show }) => ($show ? '0.563rem' : 0)} !important;
  padding-right: ${({ $show }) => ($show ? '0.563rem' : 0)} !important;
  @media only screen and (max-width: 700px) {
    padding: 0 !important;
  }
`

const ContentContainer = (props: ActionCardProps) => {
  const { showCheckbox } = props

  return (
    <Wrapper $show={showCheckbox || false}>
      <IdeasCommentTitleLink {...props} />
      <CardTitle {...props} />
      <CardContentDesc {...props} />
    </Wrapper>
  )
}

export default React.memo(ContentContainer)
